import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon, AlertCircleIcon, CreditCardIcon, ArrowRightIcon } from 'lucide-react';
import { CartItem } from './CartItem';
export const Cart = ({
  isOpen,
  onClose,
  cart,
  onRemoveItem,
  onUpdateQuantity,
  total,
  onCursorChange
}) => {
  const [headerHeight, setHeaderHeight] = useState(80); // Default header height estimate
  // Measure the actual header height on mount and window resize
  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('header');
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };
    // Initial measurement
    updateHeaderHeight();
    // Update on resize
    window.addEventListener('resize', updateHeaderHeight);
    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
    };
  }, []);
  return <div className={`fixed top-0 right-0 w-full sm:w-96 glass border-l border-[#1a2a40]/50 z-50 transform transition-transform duration-500 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
    height: '100vh',
    paddingTop: `${headerHeight}px` // Add padding to account for header height
  }} data-id="element-1212">
      <div className="flex flex-col h-full" data-id="element-1213">
        {/* Cart header */}
        <div className="p-4 border-b border-[#1a2a40]/50 flex justify-between items-center" data-id="element-1214">
          <div className="flex items-center" data-id="element-1215">
            <ShoppingBagIcon size={18} className="text-[#6ff8f0] mr-2" data-id="element-1216" />
            <h3 className="text-[#e0e6f0] font-bold font-heading" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1217">
              SPECIMEN CONTAINER
            </h3>
          </div>
          <button className="p-2 text-[#a0c0e0] hover:text-[#6ff8f0] transition-colors duration-300" onClick={onClose} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Close cart" data-id="element-1218">
            <XIcon size={18} data-id="element-1219" />
          </button>
        </div>
        {/* Cart items */}
        <div className="flex-1 overflow-y-auto p-4" data-id="element-1220">
          {cart.length === 0 ? <div className="h-full flex flex-col items-center justify-center text-center" data-id="element-1221">
              <div className="w-16 h-16 rounded-full glass border border-[#1a2a40]/50 flex items-center justify-center mb-4" data-id="element-1222">
                <ShoppingBagIcon size={24} className="text-[#a0c0e0]" data-id="element-1223" />
              </div>
              <p className="text-[#a0c0e0] font-mono mb-2" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1224">
                YOUR CONTAINER IS EMPTY
              </p>
              <p className="text-[#a0c0e0] text-sm" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1225">
                Add specimens to your collection
              </p>
            </div> : <div className="space-y-4" data-id="element-1226">
              {cart.map(item => <CartItem key={item.id} item={item} onRemove={onRemoveItem} onUpdateQuantity={onUpdateQuantity} onCursorChange={onCursorChange} data-id="element-1227" />)}
            </div>}
        </div>
        {/* Cart footer */}
        <div className="p-4 border-t border-[#1a2a40]/50" data-id="element-1228">
          {/* Order summary */}
          <div className="mb-4" data-id="element-1229">
            <div className="flex justify-between items-center mb-2" data-id="element-1230">
              <span className="text-[#a0c0e0] font-mono" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1231">
                SUBTOTAL
              </span>
              <span className="text-[#e0e6f0] font-mono" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1232">
                ${total.toFixed(2)}
              </span>
            </div>
            <div className="flex justify-between items-center mb-2" data-id="element-1233">
              <span className="text-[#a0c0e0] font-mono" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1234">
                SHIPPING
              </span>
              <span className="text-[#e0e6f0] font-mono" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1235">
                CALCULATED AT CHECKOUT
              </span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-[#1a2a40]/50" data-id="element-1236">
              <span className="text-[#6ff8f0] font-mono font-bold" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1237">
                TOTAL
              </span>
              <span className="text-[#6ff8f0] font-mono font-bold" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1238">
                ${total.toFixed(2)}
              </span>
            </div>
          </div>
          {/* Checkout button */}
          <button className={`w-full py-3 rounded flex items-center justify-center gap-2 font-mono transition-all duration-300 ${cart.length > 0 ? 'bg-[#6ff8f0]/20 text-[#6ff8f0] hover:bg-[#6ff8f0]/30 border border-[#6ff8f0]/50' : 'bg-[#1a2a40]/50 text-[#a0c0e0] cursor-not-allowed border border-[#1a2a40]'}`} disabled={cart.length === 0} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-1239">
            {cart.length > 0 ? <>
                <CreditCardIcon size={16} data-id="element-1240" />
                <span data-id="element-1241">PROCEED TO CHECKOUT</span>
                <ArrowRightIcon size={16} data-id="element-1242" />
              </> : <>
                <AlertCircleIcon size={16} data-id="element-1243" />
                <span data-id="element-1244">CONTAINER EMPTY</span>
              </>}
          </button>
          {/* Security notice */}
          <div className="mt-4 flex items-start gap-2 text-xs text-[#a0c0e0] font-mono" data-id="element-1245">
            <AlertCircleIcon size={12} className="mt-0.5 text-[#6ff8f0]" data-id="element-1246" />
            <span data-id="element-1247">
              All transactions are encrypted and secured. Your biological data
              will be processed according to our standard procedures.
            </span>
          </div>
        </div>
      </div>
    </div>;
};